import { StationModuleKind } from "../types";

type HasStationModuleKind = {
  kind?: StationModuleKind;
};

export const shouldIgnoreNeighbor = ({ kind }: HasStationModuleKind = {}) =>
  kind === undefined || kind === "SolarPanel";
